import React from 'react';

import ScrollableAnchor from 'react-scrollable-anchor';
import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';

import sectionDivider from 'images/ring-divider.svg';

export const SectionDivider = styled.div<{ $anchorOnly?: boolean }>`
  && {
    background: url(${sectionDivider}) repeat-x left top;
    background-size: 8px 8px;
    padding-top: 2rem;
    margin-top: 2em;
    flex-basis: 100%;

    ${ifProp(
      '$anchorOnly',
      css`
        background: none;
        margin: 0;
        padding: 0;
      `
    )}
  }
`;

export interface SpacerProps {
  data: {
    anchorId?: string;
    anchorOnly?: boolean;
  };
}

const Spacer: React.FC<SpacerProps> = ({ data }) => {
  const { anchorId, anchorOnly } = data;

  return (
    <>
      {anchorId ? (
        <ScrollableAnchor id={anchorId}>
          <SectionDivider $anchorOnly={anchorOnly} />
        </ScrollableAnchor>
      ) : (
        <SectionDivider />
      )}
    </>
  );
};

export default React.memo(Spacer);
